/* The United States market pack: what src/config/region.ts loads when the
   site is built with REACT_APP_REGION=us. Typed as RegionPack, so tsc checks
   its copy has every section au has. */
import type { RegionPack } from '../../region';
import region from './region.json';
import seo from './seo.json';
import * as content from './content';

export const pack: RegionPack = { region, seo, content };
